import { useAppConfig } from "@/api/app-config/useAppConfig";

interface IUseIsBillingDisabledReturn {
  isBillingDisabled: boolean;
}

export const useIsBillingDisabled = (): IUseIsBillingDisabledReturn => {
  const { data } = useAppConfig();

  // NOTE: Default to true (billing disabled) while loading to prevent flashing billing UI
  return { isBillingDisabled: data?.isBillingDisabled ?? true };
};
